<template>

  <div>
    <!-- BEGIN: Plans Details -->
    <div id="upload-planning-files-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <div class="flex items-center justify-between w-full">
              <h2 class="font-medium text-base mr-auto">Packet Planning Details</h2>
              <div>
                <!-- <button class="btn btn-primary mr-3" v-if="([1,2,8].includes(user_details.user_role) && page_data.packet_details.status == 1 && page_data.packet_details.status == 1) || ([4,6,5].includes(user_details.user_role) && page_data.packet_details.status == 2)" @click="addNewPlanning(page_data.pack_id)">Add Planning</button>
                            <button class="btn btn-primary mr-3" v-if="([1,2,8].includes(user_details.user_role) && page_data.packet_details.pack_type == 1)" @click="addNewPlanning(page_data.pack_id)">Add Planning</button>
                            <button class="btn btn-primary" v-if="page_data.plan_details.length > 0" v-print="'#planning-details'">Print</button> -->
              </div>
            </div>
          </div>
          <div class="modal-body p-3">

            <p class="font-medium text-base mr-auto"><b>Packet Number : </b>{{ page_data.plan_upload_details.number }} {{
              page_data.plan_upload_details.vepari_no ? ' ( ' + page_data.plan_upload_details.vepari_no + ' ) ' : '' }}
            </p>

            <Dropzone ref-key="dropzoneSingleRef" :options="{
              url: page_data.base_url + 'api/plan/upload_planning_file',
              thumbnailWidth: 150,
              maxFilesize: 0.5,
              headers: { Authorization: 'Bearer ' + page_data.token }
            }" class="dropzone mb-4">
              <div class="text-lg font-medium">
                Drop files here or click to upload.
              </div>
              <div class="text-gray-600">
                Upload Excel file with latest Planning Files. (.xlsx, .xls)
              </div>
            </Dropzone>

            <div class="flex w-full justify-end items-center">
              <button class="btn btn-primary btn-sm" @click="uploadPlanningFiles"
                :disabled="page_data.plan_upload_details.loading == true || page_data.uploaded_fn.length == 0">
                Upload Files
                <LoadingIcon v-if="page_data.plan_upload_details.loading == true" icon="oval" color="white"
                  class="w-4 h-4 ml-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Plan Details -->
  </div>

</template>

<script setup>
import { BASE_URL } from "@/constants/config";
import { inject, onMounted, provide, reactive, ref } from "vue";

const emit = defineEmits(['getPacketPlans'])

const swal = inject('$swal')
const page_data = reactive({

  base_url: BASE_URL,
  token: localStorage.getItem('token'),
  upload_packet_id: "",
  pack_code: "",
  uploaded_fn: [],
  plan_upload_details: {
    id: '0',
    number: '',
    vepari_no: '',
    loading: false
  },
})

const dropzoneSingleRef = ref()

provide('bind[dropzoneSingleRef]', el => {
      dropzoneSingleRef.value = el
    })

const uploadPlanningFiles = () => {

  if (page_data.uploaded_fn.length > 0) {

    let params = {
      file_items: page_data.uploaded_fn,
      packet_id: page_data.plan_upload_details.id
    }
    page_data.plan_upload_details.loading = true

    axios({
      url: 'api/plan/read_planning_file',
      method: 'post',
      baseURL: BASE_URL,
      data: params,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      config: { headers: { 'Accept': 'application/json' } }
    }).then((res) => {


      let pkt_id = page_data.plan_upload_details.id
      let pkt_no = page_data.plan_upload_details.number
      page_data.plan_upload_details.loading = false
      page_data.plan_upload_details.id = ''
      page_data.upload_packet_id = ''
      page_data.plan_upload_details.number = ''
      page_data.plan_upload_details.vepari_no = ''
      page_data.uploaded_fn = []

      swal.fire({
        text: "Files Uploaded.",
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK!",
        heightAuto: false,
        customClass: {
          confirmButton: "btn fw-semibold btn-light-danger",
        },
        timer: 2000
      });
      cash('#upload-planning-files-modal').modal('hide')
      page_data.pack_code = pkt_no
      // getPacketPlans(pkt_id)
      emit('getPacketPlans', pkt_id)
    }).catch((err) => {
      page_data.plan_upload_details.loading = false
      swal('Warning', 'Something went wrong.', 'warning')

    })
  } else {
    swal('Warning', 'Upload file First', 'warning')
  }
}

onMounted(() => {

  const elDropzoneSingleRef = dropzoneSingleRef.value
  elDropzoneSingleRef.dropzone.on('success', (data, response) => {

    page_data.uploaded_fn.push(response.fn);
  })
  elDropzoneSingleRef.dropzone.on('error', () => {
    alert('Something went wrong!')
  })
})

const show = (data) => {

  page_data.plan_upload_details.number = data.number
  page_data.plan_upload_details.vepari_no = data.vepari_no
  page_data.plan_upload_details.id = data.id
  page_data.upload_packet_id = data.id

  cash('#upload-planning-files-modal').modal('show')
}
defineExpose({
  show
})
</script>
